export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    // Normalizar caracteres Unicode (remover tildes)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Reemplazar espacios y caracteres especiales con guiones
    .replace(/[^a-z0-9]+/g, '-')
    // Remover guiones múltiples
    .replace(/-+/g, '-')
    // Remover guiones al inicio y final
    .replace(/^-|-$/g, '');
}

export function unslugify(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Generate a URL for an event based on its ID and title
 * @param id Event ID
 * @param title Event title
 * @returns URL-friendly string
 */
export function generateEventUrl(title: string): string {
  return `/event/${slugify(title)}`;
}